import React, { useState } from "react";
import { Form, Input, Button, Row, Col, DatePicker } from "antd";
import "./style.css";
import { Post } from "../../config/api";
import { PAYMENT } from "../../config/constants/api";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const PaymentComponent = ({
  amount,
  type,
  bookingId,
  planId,
  paymentProfileId,
  details,
  serviceType,
  passengerCapacity,
}) => {
  const token = useSelector((state) => state.user.userToken);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const onFinish = (values) => {
    const { cardNumber, expirationDate, cvc } = values;
    const data = {
      cardNumber,
      expirationDate: moment(expirationDate?.$d).format("YYYY-MM"),
      cvc,
      amount,
    };
    Post(PAYMENT.createTransaction, data, token)
      .then((response) => {
        if (response?.status) {
          savePayment(response?.data?.transactionId);
        }
      })
      .catch((err) => {
        console.error(err);
        const errorMessage = err?.response?.data?.message || err?.message;
        
        if (errorMessage) {
          swal("System Alert", errorMessage, "error");
          setMessage(errorMessage);
        } else {
          setMessage("An error occurred. Please try again.");
        }
      });
  };
  const savePayment = async (transactionId) => {
    try {
      const data = {
        transactionId,
        amount,
        currency: "USD",
        type,
        // description: "Payment for buying subscription plan",
      };
      if (type === "Booking") {
        data.booking = bookingId;
      }
      if (type === "Subscription") {
        data.planId = planId;
        data.actualAmount = details?.actualRate;
        data.dicountedAmount = details?.discountedRate;
        data.serviceType = serviceType;
        data.passengerCapacity = passengerCapacity;
      }
      const response = await Post(PAYMENT.savePayment, data, token);
      if (response?.status) {
        swal("System Alert", response?.message, "success");
        navigate("/");
      } else {
        setMessage("An unexpected error occurred.");
      }
    } catch (err) {
      console.error(err);
      const errorMessage = err?.response?.data?.message || err?.message;
      
      if (errorMessage) {
        swal("System Alert", errorMessage, "error");
        setMessage(errorMessage);
      } else {
        swal("System Alert", "An unexpected error occurred.", "error");
        setMessage("An unexpected error occurred.");
      }
    }
  };
  const payUsingCard = async () => {
    const data = {
      paymentProfileId,
      amount,
    };
    Post(PAYMENT.createTransactionWithSavedCard, data, token)
      .then((response) => {
        if (response?.status) {
          savePayment(response?.data?.transactionId);
        }
      })
      .catch((err) => {
        console.error(err);
        const errorMessage = err?.response?.data?.message || err?.message;
        
        if (errorMessage) {
          swal("System Alert", errorMessage, "error");
          setMessage(errorMessage);
        } else {
          swal("System Alert", "An error occurred. Please try again.", "error");
          setMessage("An error occurred. Please try again.");
        }
      });
  };
  return (
    <div className="container-fluid">
      <div className="row d-flex justify-content-center">
        <div className="col-sm-12">
          <div className="card2 relative payment-card-box">
            <p className="font-bold font-goldman xldesktop:text-[22px] laptop:text-[16px] text-center pb-4">
              PAYMENT DETAILS
            </p>
            {!paymentProfileId ? (
              <Form
                name="paymentForm"
                className="card-details"
                onFinish={onFinish}
                layout="vertical"
              >
                <Form.Item
                  label="Card Number"
                  name="cardNumber"
                  rules={[
                    { required: true, message: "Card number is required!" },
                    {
                      pattern: /^[0-9]{16}$/,
                      message: "Card number must be 16 digits.",
                    },
                  ]}
                >
                  <Input
                    placeholder="4111111111111111"
                    maxLength={16}
                    prefix={
                      <img
                        src="https://img.icons8.com/color/48/000000/visa.png"
                        width="24"
                        height="24"
                        alt="Visa"
                      />
                    }
                  />
                </Form.Item>

                <Form.Item
                  label="Cardholder's Name"
                  name="cardHolderName"
                  rules={[
                    {
                      required: true,
                      message: "Cardholder's name is required!",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      // className="pr-4"
                      label="Expiration Date"
                      name="expirationDate"
                      rules={[
                        {
                          required: true,
                          message: "Expiration date is required!",
                        },
                      ]}
                    >
                      <DatePicker
                        placeholder="YYYY/MM"
                        picker="month"
                        format="YYYY/MM"
                        className="btn"
                        //   onChange={handleDateChange}
                        style={{ width: "100%", background: "none" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="CVC"
                      name="cvc"
                      rules={[
                        { required: true, message: "CVC is required!" },
                        {
                          pattern: /^[0-9]{3}$/,
                          message: "CVC must be a 3-digit number.",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="&#9679;&#9679;&#9679;"
                        maxLength={3}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item className="text-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary web-btn h-10"
                  >
                    pay now!
                  </Button>
                </Form.Item>
                {message && (
                  <div className="error-text" id="payment-message">
                    {message}
                  </div>
                )}
              </Form>
            ) : (
              <Button
                type="primary"
                className="btn btn-primary web-btn h-10"
                onClick={payUsingCard}
              >
                pay now!
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentComponent;
